<!-- Global Alerts Layout (Error & Success Floating Notifications Container) -->
<div class="position-fixed top-0 end-0 p-3 z-3 d-flex flex-column gap-2" style="max-width: 350px">
  @if (errorMessage()) {
  <div
    class="alert alert-danger alert-dismissible shadow border-danger border-opacity-25 fade show d-flex align-items-center gap-2 m-0 font-monospace py-2.5"
    role="alert">
    <i class="bi bi-exclamation-triangle-fill flex-shrink-0 text-danger fs-5"></i>
    <div class="small lh-sm flex-grow-1 pe-2"><strong>Execution Error:</strong> {{ errorMessage() }}</div>
    <button type="button" class="btn-close shadow-none top-50 translate-middle-y my-0 end-0 me-2"
      aria-label="Close"></button>
  </div>
  } @if (successMessage()) {
  <div
    class="alert alert-success alert-dismissible shadow border-success border-opacity-25 fade show d-flex align-items-center gap-2 m-0 font-monospace py-2.5"
    role="alert">
    <i class="bi bi-check-circle-fill flex-shrink-0 text-success fs-5"></i>
    <div class="small lh-sm flex-grow-1 pe-2">{{ successMessage() }}</div>
    <button type="button" class="btn-close shadow-none top-50 translate-middle-y my-0 end-0 me-2"
      aria-label="Close"></button>
  </div>
  }
</div>

<div>
  @if (isSuperAdminAndAdmin()) {
  <div class="d-flex justify-content-start align-items-center">
    <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#createSurveyModal">
      Create
    </button>
  </div>
  }

  <div class="table-responsive mt-2">
    <table class="table">
      <thead>
        <tr>
          <th>SrNo</th>
          <th>Name</th>
          <th>Start Date</th>
          <th>End Date</th>
          <th>Period</th>
          <th>Status</th>
          @if (isSuperAdminAndAdmin()) {
          <th class="text-center text-nowrap" style="width: 80px;"></th>
          }
        </tr>
      </thead>
      <tbody>
        @for (data of surveyList()
        | paginate : { itemsPerPage: pageSize(), currentPage: page(), totalItems:
        allTotal() }; track data.srNo; let i = $index) {
        <tr (dblclick)="goToSurveyInfo(data.surveyId)">
          <td>{{data.srNo}}</td>
          <td>{{data.name}}</td>
          <td>{{data.startDate | dateFormat }}</td>
          <td>{{data.endDate | dateFormat }}</td>
          <td>{{data.period}}</td>
          <td>
            <span class="badge" [ngClass]="statusMap[data.status]?.class">
              {{ statusMap[data.status]?.label }}
            </span>
          </td>
          @if (isSuperAdminAndAdmin()) {
          <td class="text-center text-nowrap">

            <div class="d-flex align-items-center gap-2 w-100">

              <!-- CLOSE BUTTON (Only visible when active) -->
              @if (data.status === 'ACTIVE') {
              <button class="btn btn-sm btn-outline-warning d-flex align-items-center gap-1"
                (click)="closedSurvey(data.surveyId)" title="Close Survey">
                <i class="bi bi-lock"></i>
                <span>Close</span>
              </button>
              } @else {
              <button class="btn btn-sm btn-outline-success d-flex align-items-center gap-1"
                (click)="activeSurvey(data.surveyId)" title="Active Survey">
                <i class="bi bi-check-circle"></i>
                <span>Active</span>
              </button>
              }

              <!-- REMOVE BUTTON -->
              <button class="btn btn-sm btn-outline-danger d-flex align-items-center gap-1"
                (click)="removeSurvey(data.surveyId)" title="Remove Survey">
                <i class="bi bi-trash"></i>
                <span>Remove</span>
              </button>

              <!-- DEALER LIST -->
              <button class="btn btn-sm btn-outline-primary d-flex align-items-center gap-1 ms-auto"
                (click)="viewDealerList(data.surveyId)" title="View Dealer List">
                <i class="bi bi-people"></i>
                <span>Dealers</span>
              </button>

            </div>


          </td>
          }
        </tr>
        }
      </tbody>
    </table>
  </div>

  <footer>
    <div class="text-center">
      <pagination-controls [maxSize]="20" previousLabel="Prev" nextLabel="Next" [responsive]="true"
        (pageChange)="handlePageChange($event)"></pagination-controls>
    </div>
  </footer>

  @if (loading()) {
  <div class="d-flex flex-column justify-content-center align-items-center py-5">
    <div class="spinner-border text-primary mb-2" role="status"></div>
    <span class="text-muted">Loading data...</span>
  </div>
  }

</div>

<!-- Create Survey Model -->
<div class="modal" id="createSurveyModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Create Survey</h5>
      </div>
      <div class="modal-body">
        <form [formGroup]="createSurveyForm">
          <div class="mb-3">
            <label class="form-label">Name</label>
            <input type="text" class="form-control" formControlName="name">
          </div>
          <div class="mb-3">
            <label class="form-label">Start Date (DD/MM/YYYY)</label>
            <div class="input-group">
              <input type="text" class="form-control" formControlName="startDate" placeholder="DD/MM/YYYY" ngbDatepicker
                #dSurveyStart="ngbDatepicker">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" (click)="dSurveyStart.toggle()" type="button">
                  <i class="bi bi-calendar3"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label">End Date (DD/MM/YYYY)</label>
            <div class="input-group">
              <input type="text" class="form-control" formControlName="endDate" placeholder="DD/MM/YYYY" ngbDatepicker
                #dSurveyEnd="ngbDatepicker">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" (click)="dSurveyEnd.toggle()" type="button">
                  <i class="bi bi-calendar3"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label">Period</label>
            <input type="text" class="form-control" formControlName="period">
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" (click)="createSurvey()"
          [disabled]="!createSurveyForm.valid || isUploading()">
          @if (isUploading() ) {
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          } @else {
          <span>Submit</span>
          }
        </button>
      </div>
    </div>
  </div>
</div>
